import { useQuery } from "@tanstack/react-query";
import isPes from "src/helpers/isPes";
import newApi from "src/newApi";

import options from "./defaultOptions";

export function useTerms() {
	const specId = newApi.getUserSpecialization();
	const queryKey = isPes() ? `terms-pes-${specId}` : "terms-lek";

	return useQuery({
		queryKey: [queryKey],
		queryFn: () => newApi.getTerms(),
		...options,
	});
}
